import React from "react";

// components
import DataTable from "../../../component/element/table";

// types and dispatch
import {
  delete_type,
  get_opportunities_type,
} from "../../../services/apis/opportunity";
import { useAppDispatch, useAppSelector } from "../../../store";
import { ColumnDef } from "@tanstack/react-table";
import { IOpportunityTypes } from "../../../store/types/opportunity";
import { FaComputer, FaPersonWalking } from "react-icons/fa6";
import PopConfirm from "../../../component/ui/PopConfirm";
import { LuLoader, LuTrash } from "react-icons/lu";

const TypeTable = () => {
  const dispatch = useAppDispatch();
  const types = useAppSelector(
    ({ opportunity }) => opportunity.opportunity_types,
  );
  const loadingTypeId = useAppSelector(
    ({ opportunity }) => opportunity.loadingOpportunityTypeId,
  );

  const onLoad = React.useCallback(() => {
    get_opportunities_type(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const columns: ColumnDef<IOpportunityTypes>[] = [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ getValue }) => {
        const type = getValue() as string;

        // Define background colors for different types
        const bgColors = {
          physical: "bg-blue-50 text-blue-800", // Soft Blue for Physical
          online: "bg-yellow-50 text-yellow-800", // Soft Green for Online
        };

        return (
          <span className={`rounded-md flex items-center`}>
            {type && (
              <div
                className={`flex items-center gap-2 text-xs font-medium px-2 py-1 rounded-full  capitalize ${bgColors[type as keyof typeof bgColors]}`}
              >
                <span>
                  {type === "physical" ? <FaPersonWalking /> : <FaComputer />}
                </span>
                <span>{type}</span>
              </div>
            )}
          </span>
        );
      },
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ getValue }) => {
        const status = getValue() as string;
        return (
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${status === "1" ? "bg-primary-100/50 text-primary-500" : "bg-red-50 text-red-800"}`}
          >
            {status === "1" ? "active" : "not active"}
          </span>
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ row }) => {
        const { id, name } = row.original;
        return (
          <div className="flex items-center gap-3">
            <PopConfirm
              title="Delete this opportunity type?"
              description="Opportunities using this type may be affected."
              confirmText="Delete"
              onConfirm={() => delete_type(id, dispatch)}
            >
              <button
                type="button"
                disabled={loadingTypeId === id}
                aria-label={`Delete ${name}`}
                className="bg-red-50 hover:bg-red-300 text-red-800 p-2 rounded-md disabled:opacity-50"
              >
                {loadingTypeId === id ? (
                  <LuLoader size={18} className="animate-spin" />
                ) : (
                  <LuTrash size={18} />
                )}
              </button>
            </PopConfirm>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <DataTable columns={columns} data={types} />
    </>
  );
};

export default TypeTable;
